import { render, staticRenderFns } from "./CourseInfoContentInfo.vue?vue&type=template&id=1329705d&"
import script from "./CourseInfoContentInfo.vue?vue&type=script&lang=js&"
export * from "./CourseInfoContentInfo.vue?vue&type=script&lang=js&"
import style0 from "./CourseInfoContentInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports